<template>
    <button
        type="button"
        class="a-m-items-close-button m-items-close-button"
        :aria-label="ariaLabel"
        @click="onClick"
    >
        <svg-icon
            original
            name="icons/close-circle"
            class="m-items-close-button__icon"
        />
    </button>
</template>

<script>
export default {
    name: 'AMItemsCloseButton',
    props: {
        ariaLabel: {
            type: String,
            default: 'Close button'
        }
    },
    methods: {
        onClick() {
            this.$emit('onClick', true);
        }
    }
}
</script>

<style lang="scss">
@import "a-m-items-close-button";
</style>